import React from 'react'

export default function RollingHills({className}) {
    return (
        <div aria-hidden={true} className={`hidden lg:block bg-fixed absolute inset-0 bg-cover pointer-events-none ${className || "bg-rolling-hills"}`}></div>
    )
}
